const getScope = (state) => state.modules.common.helpMode;

export const getId = (state) => getScope(state).id;
